import React, { createRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Portal from '../utils/Portal';
import styles from './Outline.module.less';
import { POINTER_DOWN } from '../../util/supportedEvents';
import TransitionTarget from '../Transition/TransitionTarget';
import constants from '../../settings/constants';
import { selectIsMobilePortrait } from '../../state/userAgent/userAgentSelectors';

class Outline extends TransitionTarget {
  static propTypes = {
    className: PropTypes.string,
    isMobilePortrait: PropTypes.bool,
    targetRect: PropTypes.object,
    target: PropTypes.any,
    onClose: PropTypes.func,
    screensaverMode: PropTypes.string,
  };

  _root = createRef();
  classNames = styles;

  componentDidMount() {
    window.addEventListener(POINTER_DOWN, this.onPointerDown);
  }

  componentWillUnmount() {
    window.removeEventListener(POINTER_DOWN, this.onPointerDown);
  }

  onPointerDown = event => {
    if (this.props.screensaverMode !== constants.SCREENSAVER_MODE.countdown) {
      this.props.onClose && this.props.onClose();
    }
  };

  _getTargetPos = () =>
    this.props.targetRect || this.props.target.getBoundingClientRect();
  // eslint-disable-next-line no-dupe-class-members
  static propTypes = {};

  render() {
    const targetRect = this._getTargetPos();

    const padding = this.props.isMobilePortrait
      ? constants.OUTLINE_PADDING_MOBILE_PORTRAIT
      : constants.OUTLINE_PADDING;

    return (
      <Portal>
        <div
          className={classNames(
            styles.itemHighlight,
            this.props.className,
            this.getTransitionClassNames()
          )}
          style={{
            position: 'fixed',
            top: targetRect.y - padding,
            left: targetRect.x - padding,
            width: targetRect.width + padding * 2,
            height: targetRect.height + padding * 2,
          }}
        />
      </Portal>
    );
  }
}

export default connect(state => ({
  screensaverMode: state.screensaver.mode,
  isMobilePortrait: selectIsMobilePortrait(state),
}))(Outline);
